import type { DefaultTheme } from 'styled-components';
import { widgetButtonDefaults } from '@elfsight/widget-ui';
import { defaultBackgroundSettings } from '../../constants';
import { defaultFormAppearance } from './default-form-appearance';

export const defaultTheme: DefaultTheme = {
  heading: {
    color: '',
    fontSize: 0
  },
  timer: {
    animation: 'none',
    separatorColor: '',
    separatorStyle: 'none',
    showLabels: false,
    timeFormat: 'auto',
    timerColor: '',
    size: 0,
    timerBackgroundColor: '',
    timerStyle: 'clean',
    unitLabelColor: ''
  },
  popup: {
    background: defaultBackgroundSettings,
    borderRadius: 0,
    fullscreen: false,
    margin: 0,
    paddingHorizontal: 0,
    paddingVertical: 0
  },
  form: defaultFormAppearance,
  primaryButton: widgetButtonDefaults,
  secondaryButton: widgetButtonDefaults
};
